<template>
    <v-container fluid class="main-container container-fixed h-100 d-block pa-0">
        <div class="content-block">
            <HomeTitle v-model="room"></HomeTitle>
            <v-flex xs12 px-5 my-3>
                <v-btn class="yellow-btn main-text" @click="openUser">
                    Интерфейс пользователя
                </v-btn>
            </v-flex>
            <v-layout
                id="scroll-target"
                class="devices-list scroll-layout px-6 mt-6"
                column
                v-scroll:#scroll-target="onScroll"
            >
                <div class="w-100">
                    <v-text-field
                        v-model="searchField"
                        placeholder="Поиск контроллера"
                        class="dark-input dark-round-input"
                        dense
                        hide-details
                        @change="setSearch"
                        @input="setSearch"
                        @keypress.enter="setSearch"
                    >
                        <template v-slot:append>
                            <div
                                v-html="require('!html-loader!@/assets/icons/search_icon.svg')"
                                class="d-inline-flex size-20"
                            />
                        </template>
                    </v-text-field>
                </div>
                <div v-if="controllersFiltered.length == 0 && searchField != ''" class="img-center">
                    <v-flex text-center>
                        <div
                            v-html="require('!html-loader!@/assets/images/empty-device-list.svg')"
                            class="d-inline-flex mb-8"
                        />
                        <div class="main-text text-center">
                            Не найдено сценариев
                        </div>
                    </v-flex>
                </div>
                <div v-else-if="controllersFiltered.length == 0" class="img-center">
                    <v-flex text-center>
                        <div
                            v-html="require('!html-loader!@/assets/images/empty-device-list.svg')"
                            class="d-inline-flex mb-8"
                        />
                        <div class="main-text text-center">
                            Вы пока не добавили ни одного <br> сценария
                        </div>
                    </v-flex>
                </div>
                <div v-else :key="controllersFiltered.length">
                    <div v-for="(controller, index) in controllersFiltered" :key="'controller' + index">
                        <ControllerCard :controller="controller" />
                    </div>
                </div>
            </v-layout>
        </div>
        <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
        <ModalAddController
            v-if="openAddControllerModal"
            v-model="openAddControllerModal"
            :editController="chosenController"
            :home="room.uid"
            @update="getControllers"
        />
    </v-container>
</template>

<script>
import HomeTitle from "../components/HomeTitle";
import ControllerCard from "@/components/controllers/ControllerCard";
import ModalWaiting from "@/components/modals/ModalWaiting";
import ModalAddController from "@/components/modals/ModalAddController";

export default {
    name: "ControllersPage",
    components: {
        HomeTitle,
        ControllerCard,
        ModalWaiting,
        ModalAddController,
    },
    data() {
        return {
            controllers: [],
            room: null,
            openModalWaiting: false,
            searchField: "",
            searchText: "",
            openAddControllerModal: false,
            chosenController: {},
        };
    },
    computed: {
        controllersFiltered() {
            let searchControllers = JSON.parse(JSON.stringify(this.controllers));
            if (this.searchText != "") {
                searchControllers = this.controllers.filter((el) => {
                    return el.name.toLowerCase().includes(this.searchText.toLowerCase());
                });
            }
            return searchControllers;
        },
    },
    watch: {
        room(val) {
            if (val) {
                this.getControllers();
                localStorage.RobohomeTZ = val.timezone;
            }
        },
    },
    methods: {
        setSearch() {
            setTimeout(() => {
                this.searchText = this.searchField;
            });
        },
        getControllers() {
            this.controllers = [];
            this.openModalWaiting = true;
            this.$http.get('/controllers/home/management-controller/' + this.room.uid + '/')
                .then((response) => {
                    this.controllers = response.data.results;
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        onScroll(e) {
            this.offsetTop = e.target.scrollTop;
            this.$store.commit('setScroll', this.offsetTop);
        },
        openAddController(controller = null) {
            this.chosenController = controller;
            this.openAddControllerModal = true;
        },
        openUser() {
            let childwin = window.open('https://user.robohome.volhinsoft.ru');

            setTimeout(() => {
                childwin.postMessage(
                    this.$store.state.accessToken,
                    process.env.VUE_APP_USER_URL,
                );
            }, 1000);
        },
    },
}
</script>

<style lang="scss">
.main-container .devices-list.scroll-layout {
    height: calc(100% - 155px) !important;

    .img-center {
        position: relative;
        top: calc(50% - 155px) !important;
    }
}
</style>